import { Outlet, Navigate } from 'react-router'
import Spinner from '@cloudscape-design/components/spinner'
import Box from '@cloudscape-design/components/box'
import { useAuthStore } from '@/state/authStore'

export default function GuestGuard() {
  const status = useAuthStore((s) => s.status)

  if (status === 'loading') {
    return (
      <Box textAlign="center" padding="xxl">
        <Spinner size="large" />
      </Box>
    )
  }

  if (status === 'active') return <Navigate to="/" replace />

  return <Outlet />
}
